import * as React from 'react';

export function useSafariFullScreenStylesAdjustments(shouldAddClass: boolean, className: string, shouldRunHook = true) {
    React.useEffect(() => {
        const rootElementClassList = document.documentElement.classList;
        const hasClass = rootElementClassList.contains(className);
        const shouldModifyRootElement = shouldRunHook && shouldAddClass && !hasClass;

        if (shouldModifyRootElement) {
            rootElementClassList.add(className);
        }

        return () => {
            if (shouldModifyRootElement) {
                rootElementClassList.remove(className);
            }
        };
    }, [className, shouldAddClass, shouldRunHook]);
}
